import OSS from 'ali-oss'
import moment from 'moment'

const {
  VUE_APP_OSS_REGION,
  VUE_APP_OSS_KEY_ID,
  VUE_APP_OSS_KEY_SECRET,
  VUE_APP_OSS_BUCKET,
  VUE_APP_US_OSS_REGION,
  VUE_APP_US_OSS_KEY_ID,
  VUE_APP_US_OSS_KEY_SECRET,
  VUE_APP_US_OSS_BUCKET
} = process.env

export const client = new OSS({
  region: VUE_APP_OSS_REGION,
  accessKeyId: VUE_APP_OSS_KEY_ID,
  accessKeySecret: VUE_APP_OSS_KEY_SECRET,
  bucket: VUE_APP_OSS_BUCKET,
  timeout: 10 * 60 * 1000
})

/**
 * cs-scm bucket
 */
const ALI_OSS_BUCKET_HANGZHOU = {
  region: VUE_APP_OSS_REGION,
  accessKeyId: VUE_APP_OSS_KEY_ID,
  accessKeySecret: VUE_APP_OSS_KEY_SECRET,
  bucket: VUE_APP_OSS_BUCKET,
  timeout: 10 * 60 * 1000
}
/**
 *  oss-us-west-1
 */
const ALI_OSS_BUCKET_US = {
  region: VUE_APP_US_OSS_REGION,
  accessKeyId: VUE_APP_US_OSS_KEY_ID,
  accessKeySecret: VUE_APP_US_OSS_KEY_SECRET,
  bucket: VUE_APP_US_OSS_BUCKET,
  timeout: 10 * 60 * 1000
}

/** 加速oss上传 */
const ALI_OSS_BUCKET_OSS_ACCELERATE = {
  region: 'oss-accelerate',
  accessKeyId: 'LTAI4G7E1CLWxcNZ7EEcAVJJ',
  accessKeySecret: 'HXuj7amG0UxSLul8NB8rzg27Z0d6zl',
  bucket: 'cs-scm',
  timeout: 10 * 60 * 1000
}
const ALI_OSS_BUCKET_OSS_ACCELERATE_CLIENT = {
  region: 'oss-accelerate',
  accessKeyId: 'LTAI4G7E1CLWxcNZ7EEcAVJJ',
  accessKeySecret: 'HXuj7amG0UxSLul8NB8rzg27Z0d6zl',
  bucket: 'cs-scm-photo',
  timeout: 10 * 60 * 1000
}

const useRegion = region => {
  let config = {}
  switch (region) {
    case 'oss-cn-hangzhou':
      config = ALI_OSS_BUCKET_HANGZHOU
      break
    case 'oss-us-west-1':
      config = ALI_OSS_BUCKET_US
      break
    // 专门针对客户端使用，上传到客户端上
    case 'oss-accelerate-photo':
      config = ALI_OSS_BUCKET_OSS_ACCELERATE_CLIENT
      break
    case 'oss-accelerate':
      config = ALI_OSS_BUCKET_OSS_ACCELERATE
      break

    default:
      config =
        process.env.VUE_APP_MODE === 'production'
          ? ALI_OSS_BUCKET_OSS_ACCELERATE
          : ALI_OSS_BUCKET_HANGZHOU
      break
  }
  return config
}

export function getUploadPath(file) {
  return (
    '/cs-scm/' +
    moment(new Date()).format('YYYY-MM-DD') +
    `/${new Date().getTime()}-${file?.name}`
  )
}
export function uploadFile(file) {
  try {
    const path = getUploadPath(file)
    return client.put(path, file).catch(() => {
      return Promise.reject({
        statusCode: 'error'
      })
    })
  } catch (error) {
    return Promise.error({
      statusCode: 'error'
    })
  }
}

export function multipartUpload(file, progress) {
  const path = getUploadPath(file)
  return client.multipartUpload(path, file, {
    progress: progress
  })
}

// export class OssUploadFile {
//   instance = null
//   constructor(region) {
//     this.put = this.put.bind(this)
//     this.instance = new OSS(useRegion(region))
//   }
//   static getInstance(region) {
//     if (!this.instance) {
//       this.instance = new OssUploadFile(region)
//     }
//     return this.instance
//   }
//   put(file, option = { filePath: '' }) {
//     const { filePath } = option
//     const path = filePath || getUploadPath(file)
//     return this.instance.put(path, file).catch(() => {
//       return null
//     })
//   }
// }
export class OssUploadFile {
  instance = null
  constructor(region) {
    this.put = this.put.bind(this)
    this.instance = new OSS(useRegion(region))
  }
  static getInstance(region) {
    if (!this.instance) {
      this.instance = new OssUploadFile(region)
    }
    return this.instance
  }
  put(file, option = { filePath: '' }) {
    const { filePath } = option
    const path = filePath || getUploadPath(file)
    return this.instance.put(path, file).catch(() => {
      return null
    })
  }
  multipartUpload(file, options) {
    const path = getUploadPath(file)
    return this.instance.multipartUpload(path, file, options)
  }
  abortMultipartUpload(name, uploadId) {
    return this.instance.abortMultipartUpload(name, uploadId)
  }
  cancel() {
    return this.instance.cancel()
  }
}
